import { Ds } from "@accurx/design";
import styled from "styled-components";

export const StyledDropdownMenuContent = styled(Ds.DropdownMenu.Content)`
    max-height: 500px;
`;

export const StyledDropdownHeader = styled(Ds.DropdownMenu.Header)`
    font-weight: bold;
    font-size: 0.9rem;
`;

export const StyledDropdownMenuItem = styled(Ds.DropdownMenu.Item)<{
    $hasSpaceBetween?: boolean;
}>`
    display: flex;
    gap: 0.5rem;
    align-items: flex-start;
    justify-content: ${({ $hasSpaceBetween }) =>
        $hasSpaceBetween ? "space-between" : "initial"};

    &:hover {
        text-decoration: none;
    }
`;
